(function () {
  var didScroll = false;
  var startX = 0;
  var startY = 0;
  var MOVE_THRESHOLD = 8; // px — any real swipe/drag moves more than this

  // Track real vertical page scrolling
  window.addEventListener('scroll', function () {
    didScroll = true;
  }, { passive: true });

  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest('.item-product');
    if (!card) return;
    didScroll = false;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var card = e.target.closest('.item-product');
    if (!card) return;

    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;
    var movedX = Math.abs(endX - startX);
    var movedY = Math.abs(endY - startY);

    // If the page scrolled vertically, OR the finger moved more than the
    // threshold in any direction (e.g. swiping a related-products carousel),
    // this was a scroll/swipe gesture — don't navigate.
    if (didScroll || movedX > MOVE_THRESHOLD || movedY > MOVE_THRESHOLD) return;

    // Let these keep their own native behavior — don't intercept taps on them
    var isInteractiveArea = e.target.closest(
      '.button--top, .button--bottom, .product__popup-swatch, .item-swatch'
    );
    if (isInteractiveArea) return;

    // Genuine tap (no scroll, no swipe) → go straight to the product page
    // on the FIRST tap instead of the browser treating it as a hover simulation.
    var link = card.querySelector('.thumbnail-container > a[href]');
    if (!link) return;

    e.preventDefault();
    window.location.href = link.getAttribute('href');
  }, { passive: false });
})();